import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import FImg from "../../components/common/FImg";
import Fld from "../../components/common/Fld";
import ImgUploadFld from "../../components/common/ImgUploadFld";
import Dlg from "../../components/common/Dlg";
import { ABt, filt } from "../AdminUI";

export default function BlogTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("blog", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("blog", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <ABt variant="orange" onClick={() => { setForm({ title: "", category: "Lab", author: "", status: "draft", date: new Date().toISOString().slice(0, 10), views: 0, excerpt: "", image: "" }); setModal(true); }}>+ New Post</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 13 }}>
        {filt(db.blog, ["title", "category", "author"], srch).map(b => (
          <div key={b.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, overflow: "hidden", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <FImg src={b.image} h={120} placeholder={b.category} />
            <div style={{ padding: "12px 13px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
                <span style={{ background: "rgba(232,89,60,.1)", color: C.orange, fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20 }}>{b.category}</span>
                <Badge v={b.status} />
              </div>
              <h4 style={{ fontSize: 13, fontWeight: 700, color: C.blue, marginBottom: 3, lineHeight: 1.35 }}>{b.title}</h4>
              <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 9 }}>{b.author} · {b.date} · {b.views.toLocaleString()} views</div>
              <div style={{ display: "flex", gap: 6 }}>
                <ABt variant={b.status === "published" ? "amber" : "green"} onClick={() => save({ ...b, status: b.status === "published" ? "draft" : "published" })}>{b.status === "published" ? "Unpublish" : "Publish"}</ABt>
                <ABt onClick={() => { setForm({ ...b }); setModal(true); }}>Edit</ABt>
                <ABt variant="red" onClick={() => del(b.id)}>Del</ABt>
              </div>
            </div>
          </div>
        ))}
      </div>

      {modal && <Dlg title={form.id ? "Edit Post" : "New Post"} onClose={close}>
        <Fld label="Title" value={form.title || ""} onChange={fs("title")} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Category" value={form.category || "Lab"} onChange={fs("category")} opts={["Lab", "Staffing", "Software", "Valuation", "Company"]} /><Fld label="Author" value={form.author || ""} onChange={fs("author")} /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Status" value={form.status || "draft"} onChange={fs("status")} opts={["draft", "published"]} /><Fld label="Date" value={form.date || ""} onChange={fs("date")} type="date" /></div>
        <ImgUploadFld label="Image" value={form.image || ""} onChange={fs("image")} w={140} h={90} maxDim={1200} />
        <Fld label="Excerpt" value={form.excerpt || ""} onChange={fs("excerpt")} rows={3} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Create"} Post</ABt>
      </Dlg>}
    </>
  );
}
